import Dashboard from "./Dashboard/Dashboard.jsx";

function App() {
  return (
    <>
      <Dashboard />
    </>
  );
}

export default App;
